import React from "react";
import "../styles/OurTeam.css";

const teamMembers = [
 {
    name: "Kamalanathan M",
    title: "Assistant Manager - HR",
      image: "/assets/team/kamala.jpeg",
    linkedin: "https://www.linkedin.com/in/kamalanathanm/?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B%2FE2Q%2BeKnQxizwVV6%2Bs5NiQ%3D%3D",
  },
  {
    name: "Keerthana K",
    title: "Senior - TA",
      image: "/assets/team/keerthana.jpg",
    linkedin: "https://linkedin.com/in/keerthana-k-2b9004250",
  },
  {
    name: "Sakthi V",
    title: "IT Recruiter",
      image: "/assets/team/shakthi.jpeg",
    linkedin: "linkedin.com/in/sakthi-veerapandiyan-426072345",
  },
  {
    name: "Swetha K",
    title: "IT Recruiter",
      image: "/assets/team/swetha.jpeg",
    linkedin: "linkedin.com/in/swetha-k-70b7a3275",
  },
  {
    name: "Devishree N",
    title: "IT Recruiter",
      image: "/assets/team/devishree.jpeg",
    linkedin: "https://www.linkedin.com/in/devishree-nagan-01775b386",
  },
  {
    name: "Baranidharan M",
    title: "Software Engineer",
      image: "/assets/team/bharan.jpeg",
    linkedin: "https://linkedin.com/in/baranidharan-murugesan-458209371",
  },
  {
    name: "Sanjay M",
    title: "UX/UI Designer",
      image: "/assets/team/san.jpeg",
    linkedin: "https://linkedin.com/in/sanjaymagendramani",
  },
  {
    name: "Praveen S",
    title: "Junior Software Engineer",
      image: "/assets/team/praveen.jpg",
    linkedin: "https://linkedin.com/in/praveen-samiayya-242a27250",
  },
  {
    name: "Janarthan G",
    title: "Junior Software Engineer",
      image: "/assets/team/jana.jpeg",
    linkedin: "https://www.linkedin.com/in/janarthan-g-988505281",
  },
  
  
   
   
   
 
];

export default function OurTeam() {
  return (
    <section className="team-section">
      <h2 className="team-title">People & Culture</h2>
      <p className="team-subtitle">
        A team culture built on understanding, innovation, and customization.
      </p>
      <div className="team-grid">
        {teamMembers.map((member, idx) => (
          <div className="team-card" key={idx}>
            <div className="team-photo-wrapper">
              <img src={member.image} alt={member.name} className="team-photo" />
            </div>
            <div className="team-info">
              <div className="team-name-row">
                <span className="team-name">{member.name}</span>
                <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="linkedin-icon">
                  <img src="/assets/icons/linkedin2.png" alt="LinkedIn" width={28} height={28} />
                </a>
              </div>
              <span className="team-title-job">{member.title}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
